<template>
  <div class="main">
    <div class="card text-white">
      <img src="../assets/res_img_7.jpg" class="card-img img-rounded" height=160 alt="...">
      <div class="card-img-overlay text-left">
        <h6 class="card-title text-right">会員ID： {{ this.$store.state.userinfo.cardid }}</h6>
        <h6 class="card-title text-right">{{ this.$store.state.userinfo.name }} 様</h6>
        <div class="row">
          <div class="col-9">
            <p class="card-text">発行日：<br>{{ this.$store.state.userinfo.createdate }}</p>
          </div>
          <div class="col-3">
          </div>
        </div>
      </div>
    </div>
    <ul class="list-group text-left">
      <li class="list-group-item" v-on:click="toProfile()"><i class="fa fa-pencil-square-o"></i> 登録情報の編集<i
          class="fa fa-angle-right pull-right"></i></li>
      <li class="list-group-item" v-on:click="toBind()"><i class="fa fa-envelope-o"></i> 連絡用メールアドレス<i
          class="fa fa-angle-right pull-right"></i></li>
      <li class="list-group-item" v-on:click="toPasswordChange()"><i class="fa fa-lock"></i> パスワード変更<i
          class="fa fa-angle-right pull-right"></i></li>
      <li class="list-group-item" v-on:click="toReserve()" v-if="this.$store.state.userinfo.email2"><i
          class="fa fa-calendar-check-o"></i> 予約履歴<i class="fa fa-angle-right pull-right"></i></li>
      <li class="list-group-item" v-on:click="toStamp()"><i class="fa fa-support"></i> スタンプ<i
          class="fa fa-angle-right pull-right"></i></li>
      <li class="list-group-item text-center" v-on:click="logout()">ログアウト</li>
    </ul>
  </div>
</template>
<script>
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        username: '',
        password: ''
      },
      confirmdef: {
        title: 'ログアウト',
        msg: 'ログアウトしますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  created() {
    this.$store.state.title = '会員センター'
    this.$store.state.confirmdef = this.confirmdef
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.$store.state.authenticated) {
        this.$router.replace({ name: 'Login' })
      }
    },
    logout() {
      const that = this
      $('#myModalConfirm').modal('show')
      $("#confirm").click(function () {
        $('#myModalConfirm').modal('hide')
        if (that.$router.currentRoute.name != "My") {
          return
        }
        that.$router.replace({ name: 'Login' })
      })
    },
    toProfile() {
      this.$router.replace({ name: 'Profile' })
    },
    toBind() {
      this.$router.replace({ name: 'Bind' })
    },
    toPasswordChange() {
      this.$router.replace({ name: 'PasswordChange' })
    },
    toReserve() {
      this.$router.replace({ name: 'Reserve' })
    },
    toStamp() {
      this.$router.replace({ name: 'StampList' })
    }
  }
}
</script>
<style scoped>
.main {
  font-size: 10.5pt;
}

.main .card {
  margin: 5px
}

.list-group {
  margin: 5px
}

.nav {
  padding: 20px;
}

.nav .nav-item {
  color: #343434;
}

.nav a {
  font-weight: bold;
  color: #fb6e14;
}

.nav a.router-link-exact-active {
  color: #fb6e14;
}
</style>
